import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList, rOyakEmlakVergileri, rValue } from '../../models/.catalog';

export default class OyakEmlakVergileriApi extends ApiBase<pList, rValue<rOyakEmlakVergileri>> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/OyakEmlakVergileri',
      }),
      options
    );
  }
}
